/**
 * prefixes "auth0|" to the id if necessary
 */
export function addAuth0Prefix(id: string) {
  return id.includes('auth0|') ? id : `auth0|${id}`
}
